module.exports = __webpack_public_path__ + "static/media/user.b16796f1.svg";